/**
 * Binary search
 * @param {number[]} arr - Sorted array
 * @param {number} target - Target value
 * @returns {number[]} [foundValue, foundValueIndex]
 */
export function binarySearch(arr, target) {
  let left = 0;
  let right = arr.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);

    if (arr[mid] === target) {
      return [arr[mid], mid];
    } else if (arr[mid] < target) {
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  if (right < 0) {
    return [arr[0], 0];
  } else if (left >= arr.length) {
    return [arr[arr.length - 1], arr.length - 1];
  } else {
    return Math.abs(arr[left] - target) < Math.abs(arr[right] - target)
      ? [arr[left], left]
      : [arr[right], right];
  }
}
